"use client";

import { captureException } from "@slider/logger";
import { useEffect, useState } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  const [eventId, setEventId] = useState<string | undefined>(error.digest);

  useEffect(() => {
    const id = captureException(error);
    if (id) setEventId(id);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily:
            'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          background: "#ffffff",
          color: "#0a0a0a",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
        }}
      >
        <div
          style={{
            maxWidth: "420px",
            width: "100%",
            textAlign: "center",
            border: "1px dashed #e5e5e5",
            borderRadius: "12px",
            padding: "32px 24px",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "8px",
              background: "#f5f5f5",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "16px",
            }}
            aria-hidden="true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
              <path d="M12 9v4" />
              <path d="M12 17h.01" />
            </svg>
          </div>
          <h1 style={{ fontSize: "18px", fontWeight: 500, margin: "0 0 8px" }}>
            Something went wrong on our end
          </h1>
          <p style={{ fontSize: "14px", color: "#737373", margin: "0 0 24px" }}>
            We&apos;ve been notified and are looking into it. Please try reloading the page.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              background: "#0a0a0a",
              color: "#ffffff",
              border: "none",
              borderRadius: "6px",
              padding: "8px 16px",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
        {eventId && (
          <p
            style={{
              position: "fixed",
              bottom: "16px",
              left: "50%",
              transform: "translateX(-50%)",
              fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
              fontSize: "10px",
              color: "#d4d4d4",
              margin: 0,
            }}
          >
            ref: {eventId}
          </p>
        )}
      </body>
    </html>
  );
}
